import { useLocation, useNavigate } from "react-router-dom";
import CreateInvoice from ".";
import { useAuthContext } from "../../../../../context/AuthContext";
const EnhancedCreateInvoice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {business} = useAuthContext();

  return <CreateInvoice navigate={navigate} location={location} business={business}/>;
};
export default EnhancedCreateInvoice;
